import React, { useEffect, useState } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import { getOpenJobMetrics } from "../callable-cloud-functions/cloudFunctions";
import { CircularProgressbar } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";

function JobMetrics({ employerId }) {
  ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
  );

  const [chartData, setChartData] = useState([]);
  const [chartLabels, setChartLabels] = useState([]);
  const [progress, setProgress] = useState(0);
  const [showProgress, setShowProgress] = useState(true);

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
      },
      title: {
        display: true,
        text: "Open Job Metrics",
      },
    },
    animation: {
      duration: 2000,
      onProgress: function (animation) {
        const progress = animation.currentStep / animation.numSteps;
        const rounded = Math.round((progress + Number.EPSILON) * 100) / 100;
        const converted = rounded * 100;
        setProgress(converted);
      },
      onComplete: function (animation) {
        setTimeout(() => {
          setProgress(0);
          setShowProgress(false);
        }, 2000);
      },
    },
  };

  const data = {
    labels: chartLabels,
    datasets: chartData,
  };

  useEffect(() => {
    (async () => {
      const res = await getOpenJobMetrics(employerId);
      const SEATS = 0;
      const OFFERS = 1;
      const HIRES = 2;
      const datasets = [
        {
          label: "Seats",
          data: [],
          backgroundColor: "#4198d7",
        },
        {
          label: "Offers",
          data: [],
          backgroundColor: "#2a6a99",
        },
        {
          label: "Hires",
          data: [],
          backgroundColor: "#0c3d5b",
        },
      ];
      const labels = [];

      for (const jobMetric of res.data) {
        // res.data.forEach((jobMetric) => {
        console.log("JobMetrics.js, useEffect, jobMetric: ", jobMetric);
        const seats = jobMetric.totalSeats;
        const offers = jobMetric.totalOffers;
        const hires = jobMetric.totalHired;

        labels.push(jobMetric.jobTitle);

        datasets[SEATS].data.push(seats);
        datasets[OFFERS].data.push(offers);
        datasets[HIRES].data.push(hires);
      }
      setChartData(datasets);
      setChartLabels(labels);
    })();
  }, []);

  return (
    <div>
      {showProgress ? (
        <div style={{ width: 200, height: 200, margin: "auto" }}>
          <span>Open Job Metrics</span>
          <CircularProgressbar
            value={progress}
            text={`${progress}%`}
            maxValue={50}
          />
        </div>
      ) : (
        <div style={{ display: "none" }} />
      )}
      <div style={{ width: "100%", height: "100%" }}>
        <Bar
          style={showProgress ? { display: "none" } : { display: "block" }}
          options={options}
          data={data}
        />
      </div>
    </div>
  );
}

export default JobMetrics;
